module.exports = __webpack_public_path__ + "static/img/NCBI.2ec65fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NCBI.png
// module id = HeHZ
// module chunks = 1